import { Sizes } from "../_app/cuchillo/core/Sizes";

export default class Ground {
  scale = .7;
  position = {
    x: 0,
    y: 0,
    yVariation: 0,
  }
  size = {
    width: (1090 * Sizes.RATIO) * this.scale,
    height: (460 * Sizes.RATIO) * this.scale,
    offset: 23 * Sizes.RATIO,
  }

  constructor(__call) {
    this.image = new Image();
    this.image.src = IMAGE_GROUND;

    this.position.y = (540 * Sizes.RATIO) - this.size.height;

    this.image.onload = __call;
  }

  update(__speed, __y) {
    let newPos =  this.position.x - (__speed * .8);
    if(newPos <= -this.size.width) {
      newPos = this.size.width + newPos;
    }
    this.position.x = newPos;
  }

  draw(ctx) {
    ctx.drawImage(this.image, this.position.x, this.position.y, this.size.width, this.size.height);
    ctx.drawImage(this.image, this.position.x + this.size.width, this.position.y, this.size.width, this.size.height);
  }

  dispose() {
    // Eliminar referencia a la imagen
    this.image.src = "";
    this.image.onload = null;
    this.image = null;
  
    // Restablecer propiedades a sus valores iniciales o null
    this.position = {
      x: 0,
      y: 0,
      yVariation: 0
    }
  }
}
